(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('GroupPracticeService', ['$http', GroupPracticeServiceFn]);
    
    function GroupPracticeServiceFn($http, $rootScope, $uibModalStack, $uibModal) {

        var baseUrl = '/api/grouppractices/';
        var service = {
            getGroupPractices,
            getGroupPractice,
            getGroupPracticeUsers,
            createGroupPractice,
            updateGroupPractice,
            deleteGroupPractice,
            getWaitingRooms,
            getWaitingRoom,
            createWaitingRoom,
            updateWaitingRoom,
            deleteWaitingRoom,
            getInternalLocations,     
            getInternalLocation,
            createInternalLocation,
            updateInternalLocation,
            deleteInternalLocation       
        };

        return service;

        function get(url) {
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        });
        }
        function getGroupPractices() {
            return get(`${baseUrl}`);
        }
        function getGroupPracticeUsers(userId) {
            return get(`${baseUrl}users/${userId}`);
        }
        function getGroupPractice(groupPracticeId) {
            return get(`${baseUrl}${groupPracticeId}`);
        }
        function createGroupPractice(groupPractice) {
                    return $http.post(`${baseUrl}`, groupPractice)
                                .then(function (response) {
                        return response.data;
                    });
        }
        //endpoint to be implemented
        function updateGroupPractice(groupPractice) {
            return $http.put(`${baseUrl}`, groupPractice)
                        .then(function (response) {
                return response.data;
            });
        }

         function deleteGroupPractice(groupPractice) {
            return $http.delete(`${baseUrl}${groupPractice.id}`)
                        .then(function (response) {                
                return response.data;
            });
         }
        function deleteWaitingRoom(groupPracticeId, waitingRoomId) {
            return $http.delete(`${baseUrl}${groupPracticeId}/waitingrooms/${waitingRoomId}`)
                        .then(function (response) {
                return response.data;
            });
        }        
        function getWaitingRooms(groupPracticeId) {
            return get(`${baseUrl}${groupPracticeId}/waitingrooms`);
        }

        function getWaitingRoom(groupPracticeId, waitingRoomId) {
            return get(`${baseUrl}${groupPracticeId}/waitingrooms/${waitingRoomId}`);
        }

        function createWaitingRoom(groupPracticeId, waitingRoom) {
            return $http.post(`${baseUrl}${groupPracticeId}/waitingrooms`, waitingRoom)
                        .then(function (response) {
                return response.data;
            });
        }
       

        function updateWaitingRoom(groupPracticeId, waitingRoomId, waitingRoom) {
            return $http.put(`${baseUrl}${groupPracticeId}/waitingrooms/${waitingRoomId}`, waitingRoom)
                        .then(function (response) {
                return response.data;
            });
        }

        function deleteWaitingRoom(groupPracticeId, waitingRoomId) {
            return $http.delete(`${baseUrl}${groupPracticeId}/waitingrooms/${waitingRoomId}`)
                        .then(function (response) {
                return response.data;
            });
        }

        function getInternalLocations(groupPracticeId) {
            return get(`${baseUrl}${groupPracticeId}/internal-locations`);
        }

        function getInternalLocation(groupPracticeId, locationId) {
            return get(`${baseUrl}${groupPracticeId}/internal-locations/${locationId}`);
        }

        function createInternalLocation(groupPracticeId, location) {
            return $http.post(`${baseUrl}${groupPracticeId}/internal-locations`, location)
                        .then(function (response) {
                return response.data;
            });
        }

        function updateInternalLocation(groupPracticeId, locationId, location) {
            return $http.put(`${baseUrl}${groupPracticeId}/internal-locations/${locationId}`, location)
                        .then(function (response) {
                return response.data;
            });
        }

        function deleteInternalLocation(groupPracticeId, locationId) {
            return $http.delete(`${baseUrl}${groupPracticeId}/internal-locations/${locationId}`)
                        .then(function (response) {
                            return response.data;
                        });
        }
    } 
})();